import { DateArg, getFormattedDate } from '@lib/utils/dateTimeHelpers';
import {
  dateFormatForApi,
  dateFormatForApiWithoutDays,
  dayMonthShortFormat,
  dayMonthShortYearFormat,
  dayOfMonthFormat,
  yearFormat,
} from '@lib/enums/dateTime';

// Collapses a date range into one compact label, dropping the parts that
// repeat: same day -> "8 Jul 2026", same month -> "8-15 Jul 2026", same
// year -> "28 Jun - 3 Jul 2026", otherwise the full date on both ends.
// Compares by CET calendar day/month/year (like the labels), not the raw
// timestamp.
export default function getDateRangeLabel(
  minDate: DateArg,
  maxDate: DateArg,
): string | undefined {
  if (!minDate || !maxDate) return undefined;

  const isSame = (format: string) =>
    getFormattedDate(minDate, format) === getFormattedDate(maxDate, format);
  const maxLabel = getFormattedDate(maxDate, dayMonthShortYearFormat);

  if (isSame(dateFormatForApi)) return maxLabel || undefined;
  if (isSame(dateFormatForApiWithoutDays)) {
    return `${getFormattedDate(minDate, dayOfMonthFormat)}-${maxLabel}`;
  }
  const minFormat = isSame(yearFormat)
    ? dayMonthShortFormat
    : dayMonthShortYearFormat;
  return `${getFormattedDate(minDate, minFormat)} - ${maxLabel}`;
}
